import {filter, find, get, isEmpty, padStart, values} from "lodash";
import {getPartner} from "common/helpers";

const getGroupMemberTitle = (members) => {
  let numberOfMembers = padStart(!isEmpty(members) ? members.length : '', 2, "0");
  return `${numberOfMembers} members`

};
export const messageWindowTitle = (channel, myId, isAIChannel = false) => {
  return channel.isGroup || isAIChannel
      ? channel.channelName
      : get(getPartner(channel.channelMembers, myId), "userFullName")};
export const messageWindowSubTitle = (channel, myId) => channel.isGroup ? getGroupMemberTitle(channel.channelMembers) : get(getPartner(channel.channelMembers, myId), "role");

export const getChannelFor = (id, channels) => {
  return get(filter(channels, (channel) => channel.channelId === id), '[0]', []);
};

// The group conversation for a mentorship, preferring the one the pair manager
// is in. Mirrors mentorshipGroupChannel in the Android app.
export const mentorshipGroupChannel = (channels, {mentorGroup, mentorship}) => {
  const list = values(channels);
  const inMyGroup = (channel) => Boolean(mentorGroup) && channel.mentorGroupId === mentorGroup;
  const inMyMentorship = (channel) => Boolean(mentorship) && channel.mentorshipId === mentorship;

  const preferences = [
    (channel) => inMyGroup(channel) && channel.isGroup && channel.isPairManagerChannel,
    (channel) => inMyGroup(channel) && channel.isGroup && !channel.isPairManagerChannel,
    (channel) => inMyGroup(channel) && channel.isPairManagerChannel,
    (channel) => inMyGroup(channel),
    (channel) => inMyMentorship(channel) && channel.isPairManagerChannel,
    (channel) => inMyMentorship(channel),
  ];

  return find(preferences.map((matches) => find(list, matches)), Boolean) || null;
};
